import React from 'react';
import { Box, Typography, Button, Grid, Checkbox, FormControlLabel, Card, CardContent, styled } from '@mui/material';
import { Save } from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { AccountFlags, AccountFlagsProps } from '../types/type';

const StyledCard = styled(Card) ({
  bgcolor: COLORS_ADMIN_PAGE.WHITE, 
  border: `1px solid ${COLORS_ADMIN_PAGE.BORDER}`, 
  borderRadius: '8px', 
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)', 
  minHeight: '120px', 
  display: 'flex', 
  flexDirection: 'column'
})

export const AccountFlagsComponent: React.FC<AccountFlagsProps> = ({
  accountFlags,
  onFlagChange,
  onSave,
}) => {
  return (
    <Box sx={{ position: 'relative', height: '500px' }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Account Flags
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={6}>
            <StyledCard>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, flexGrow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accountFlags.isAccountLocked}
                      onChange={(e) => onFlagChange('isAccountLocked', e.target.checked)}
                      sx={{ color: COLORS_ADMIN_PAGE.PRIMARY, '&.Mui-checked': { color: COLORS_ADMIN_PAGE.PRIMARY } }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 0.5 }}>
                        Is Account Locked?
                      </Typography>
                      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
                        Locked account are prevented from using the services
                      </Typography>
                    </Box>
                  }
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={6}>
            <StyledCard>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, flexGrow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accountFlags.isEmailVerified}
                      onChange={(e) => onFlagChange('isEmailVerified', e.target.checked)}
                      sx={{ color: COLORS_ADMIN_PAGE.PRIMARY, '&.Mui-checked': { color: COLORS_ADMIN_PAGE.PRIMARY } }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 0.5 }}>
                        Is Email Verified?
                      </Typography>
                      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
                        Accounts with verified email signifies that their email address is valid.
                      </Typography>
                    </Box>
                  }
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={6}>
            <StyledCard>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, flexGrow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accountFlags.isClientPostAllowed}
                      onChange={(e) => onFlagChange('isClientPostAllowed', e.target.checked)}
                      sx={{ color: COLORS_ADMIN_PAGE.PRIMARY, '&.Mui-checked': { color: COLORS_ADMIN_PAGE.PRIMARY } }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 0.5 }}>
                        Is Client Post Allowed?
                      </Typography>
                      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
                        Allow this user to post orders
                      </Typography>
                    </Box>
                  }
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={6}>
            <StyledCard>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, flexGrow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accountFlags.isContractorVerified}
                      onChange={(e) => onFlagChange('isContractorVerified', e.target.checked)}
                      sx={{ color: COLORS_ADMIN_PAGE.PRIMARY, '&.Mui-checked': { color: COLORS_ADMIN_PAGE.PRIMARY } }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 0.5 }}>
                        Is Contractor Verified?
                      </Typography>
                      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
                        Indicates that this user's contractor profile is verified and is allowed to accept orders.
                      </Typography>
                    </Box>
                  }
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={6}>
            <StyledCard>
              <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, flexGrow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accountFlags.isSpecialContractor}
                      onChange={(e) => onFlagChange('isSpecialContractor', e.target.checked)}
                      sx={{ color: COLORS_ADMIN_PAGE.PRIMARY, '&.Mui-checked': { color: COLORS_ADMIN_PAGE.PRIMARY } }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 0.5 }}>
                        Is Special Contractor?
                      </Typography>
                      <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
                        Indicates that this user's contractor profile is a special contractor.
                      </Typography>
                    </Box>
                  }
                />
              </CardContent>
            </StyledCard>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ position: 'absolute', bottom: 0, right: 0, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          startIcon={<Save />}
          variant="contained"
          sx={{ color: 'white' }}
          onClick={onSave}
        >
          SAVE
        </Button>
      </Box>
    </Box>
  );
};